<template>
  <v-container fill-height fluid>
    <v-layout align-center justify-center>
      <v-flex md4 sm8 xs12>
        <v-card class="elevation-12">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-toolbar color="primary" dark>
              <v-toolbar-title>Anmelden</v-toolbar-title>
              <v-progress-linear :active="loading" indeterminate absolute bottom></v-progress-linear>
            </v-toolbar>
            <v-card-text>
              <v-text-field
                :rules="nameRules"
                label="Nutzername"
                prepend-icon="mdi-account"
                required
                type="text"
                v-model="username"
                autofocus
              ></v-text-field>
              <v-text-field
                :rules="passwordRules"
                label="Passwort"
                prepend-icon="mdi-lock"
                required
                type="password"
                v-model="password"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="login" color="primary" type="submit">Anmelden</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      loading: state => state.loading,
      isConnected: state => state.socket.isConnected
    })
  },
  data() {
    return {
      valid: false,
      username: "",
      password: "",
      nameRules: [v => !!v || "Der Nutzername darf nicht leer sein"],
      passwordRules: [v => !!v || "Das Passwort darf nicht leer sein"]
    };
  },
  methods: {
    login: function() {
      if (this.$refs.form.validate()) {
        if (this.isConnected) {
          this.$store.commit("startLoading");

          this.$socket.sendObj({
            eventID:
              "de.t2med.lizenzomat.eventapi.usecase.login.LoginRequestEvent",
            username: this.username,
            password: this.password
          });
        } else {
          const self = this;
          const intervalId = setInterval(() => {
            if (this.isConnected) {
              this.$store.commit("startLoading");

              self.$socket.sendObj({
                eventID:
                  "de.t2med.lizenzomat.eventapi.usecase.login.LoginRequestEvent",
                username: this.username,
                password: this.password
              });
              clearInterval(intervalId);
            }
          }, 1000);
        }
      }
    }
  }
};
</script>
